import {
  QueryCondition,
  QueryOperation,
  SearchQuery,
} from "../code/search-query/search-query";
import { InputObject } from "../controls/default";
import { Company } from "../repository/data.default";
import { nameOf } from "../utils/typescript";
import { hasValue } from "../utils/string";

export interface CompanyTreeViewForm {
  readonly tenant: InputObject;
  readonly company: InputObject;
  readonly name: string;
  // Deliberately NOT mapped below. Department is not a field on Company, so it cannot become a condition
  // on the company query; CompanyTreeView resolves it to the owning companies first and narrows by uid.
  // The switch has no case for it, so it falls through to undefined and is filtered out — by design.
  readonly department: string;
}

export function mapCompanyTreeViewQuery(
  values: CompanyTreeViewForm,
): SearchQuery {
  const conditions: QueryCondition[] = Object.entries(values)
    .filter(([key, value]) => hasValue(value))
    .map(([key, value]) => {
      switch (key) {
        case nameOf<CompanyTreeViewForm>("tenant"):
          return {
            field: nameOf<Company>("tenantUid"),
            values: [(value as InputObject).value],
            operation: QueryOperation.Equal,
          };
        case nameOf<CompanyTreeViewForm>("company"):
          return {
            field: nameOf<Company>("uid"),
            values: [(value as InputObject).value],
            operation: QueryOperation.Equal,
          };
        case nameOf<CompanyTreeViewForm>("name"):
          return {
            field: key,
            values: [value],
            operation: QueryOperation.StartsWith,
          };
      }
    })
    .filter((f) => !!f) as QueryCondition[];
  return {
    conditions,
  };
}
